import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatErr } from "../../lib/api";

const KINDS = { pain_high: "Dolor alto", pain_moderate: "Molestia moderada", fatigue_persistent: "Fatiga persistente", pain_pattern: "Molestia repetida", wellness_drop: "Bienestar en descenso" };
const card = { padding: 16, marginBottom: 12 };
const Spark = ({ t }) => (
  <span style={{ display: "inline-flex", gap: 2, alignItems: "flex-end", height: 22 }}>
    {t.map((x, i) => <span key={i} title={`${x.date}: ${x.score ?? "—"}`} style={{ width: 6, height: Math.max(2, (x.score || 0) / 100 * 22), background: x.score == null ? "#525252" : x.score >= 60 ? "#4ade80" : x.score >= 45 ? "#facc15" : "#f87171" }} />)}
  </span>
);

export const CoachOverview = ({ go }) => {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/autoreg/overview").then((r) => setD(r.data)).catch((e) => toast.error(formatErr(e)));
  useEffect(() => { load(); }, []);
  const toggle = async () => {
    try {
      const { data } = await api.get("/admin/autoreg/rules");
      await api.put("/admin/autoreg/rules", { rules: { ...data.rules, enabled: !d.enabled } });
      toast.success(!d.enabled ? "Autorregulación activada" : "Autorregulación desactivada");
      load();
    } catch (e) { toast.error(formatErr(e)); }
  };
  const read = (id) => { setD({ ...d, alerts: d.alerts.filter((a) => a.id !== id) }); api.post(`/admin/wellness/alerts/${id}/read`).catch(load); };
  if (!d) return <div style={{ color: "#a3a3a3" }}>Cargando…</div>;
  return (
    <div data-testid="ar-overview">
      <div className="qv-card-app" style={{ ...card, display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: 220 }}><b>Autorregulación automática: </b><span style={{ color: d.enabled ? "#4ade80" : "#f87171" }} data-testid="ar-ov-state">{d.enabled ? "activada" : "desactivada"}</span>
          <div style={{ fontSize: 12, color: "#a3a3a3" }}>{d.unreviewed} ajuste(s) sin revisar · {d.pending_proposals.length} recálculo(s) esperando tu decisión</div></div>
        <button className={d.enabled ? "qv-btn-ghost" : "qv-btn-primary"} onClick={toggle} data-testid="ar-ov-toggle">{d.enabled ? "Desactivar" : "Activar"}</button>
        <button className="qv-btn-ghost" onClick={() => go("adjustments")} data-testid="ar-ov-go-adjustments">Revisar ajustes</button>
      </div>
      <div className="qv-card-app" style={card} data-testid="ar-ov-alerts">
        <div style={{ fontWeight: 800, marginBottom: 6 }}>Notificaciones ({d.alerts.length})</div>
        {!d.alerts.length && <div style={{ fontSize: 13, color: "#a3a3a3" }}>Sin avisos nuevos.</div>}
        {d.alerts.map((a) => (
          <div key={a.id} style={{ display: "flex", justifyContent: "space-between", gap: 8, flexWrap: "wrap", fontSize: 13, padding: "7px 0", borderTop: "1px solid rgba(255,255,255,0.06)" }} data-testid={`ar-ov-alert-${a.id}`}>
            <span><b style={{ color: a.kind.startsWith("pain") ? "#f87171" : "#facc15" }}>{KINDS[a.kind] || a.kind}</b> · <Link to={`/app/admin/clients/${a.client_id}?tab=bienestar`} style={{ color: "#fff" }}>{a.client_name}</Link> · {a.local_date} · {a.message || `dolor ${a.pain}/10`}</span>
            <button className="qv-btn-ghost" style={{ padding: "4px 8px", fontSize: 11 }} onClick={() => read(a.id)} data-testid={`ar-ov-alert-read-${a.id}`}>Marcar leído</button>
          </div>
        ))}
      </div>
      <div className="qv-card-app" style={card} data-testid="ar-ov-missing">
        <div style={{ fontWeight: 800, marginBottom: 6 }}>No están rellenando el cuestionario (3 días o más) ({d.missing.length})</div>
        {!d.missing.length && <div style={{ fontSize: 13, color: "#a3a3a3" }}>Todos los jugadores activos lo rellenan.</div>}
        {d.missing.map((m) => <div key={m.client_id} style={{ fontSize: 13, padding: "5px 0", borderTop: "1px solid rgba(255,255,255,0.06)" }} data-testid={`ar-ov-missing-${m.client_id}`}><b>{m.client_name}</b> · {m.last_checkin ? `último el ${m.last_checkin} (hace ${m.days_since} días)` : "nunca lo ha rellenado"}</div>)}
      </div>
      <div className="qv-card-app" style={card} data-testid="ar-ov-players">
        <div style={{ fontWeight: 800, marginBottom: 6 }}>Tendencia de recuperación (últimos 7 cuestionarios)</div>
        {d.players.map((p) => {
          const l = p.trend[p.trend.length - 1];
          return (
            <div key={p.client_id} style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", fontSize: 13, padding: "6px 0", borderTop: "1px solid rgba(255,255,255,0.06)" }} data-testid={`ar-ov-player-${p.client_id}`}>
              <Link to={`/app/admin/clients/${p.client_id}?tab=bienestar`} style={{ color: "#fff", fontWeight: 700, minWidth: 160 }}>{p.client_name}</Link>
              <Spark t={p.trend} />
              <span style={{ color: "#a3a3a3" }}>{l ? `Último: bienestar ${l.score ?? "—"} · sueño ${l.sleep ?? "—"} h · fatiga ${l.fatigue}/5 · dolor ${l.pain}/10` : "Sin cuestionarios"}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
